document.addEventListener('DOMContentLoaded', () => {
  initProductRecommendations();
  initFeatureProductRecommendations();
});

function fetchRecommendationsSection(url, selector, target) {
  return fetch(url)
    .then((response) => response.text())
    .then((text) => {
      const wrapper = document.createElement('div');
      wrapper.innerHTML = text;
      const recommendations = wrapper.querySelector(selector);

      if (!recommendations?.innerHTML.trim()) return false;

      target.innerHTML = recommendations.innerHTML;
      return true;
    });
}

function equalizeCardHeights(section) {
  const cards = section.querySelectorAll('.recomendation-card');
  const cardTitles = section.querySelectorAll('.recomendation-card__title');

  if (!cards.length) return;

  cards.forEach((card) => {
    card.style.height = 'auto';
  });

  cardTitles.forEach((title) => {
    title.style.minHeight = 'auto';
  });

  let titleMaxHeight = 0;
  let cardMaxHeight = 0;

  cardTitles.forEach((title) => {
    titleMaxHeight = Math.max(titleMaxHeight, title.offsetHeight);
  });

  cardTitles.forEach((title) => {
    title.style.minHeight = `${titleMaxHeight}px`;
  });

  cards.forEach((card) => {
    cardMaxHeight = Math.max(cardMaxHeight, card.offsetHeight);
  });

  cards.forEach((card) => {
    card.style.height = `${cardMaxHeight}px`;
  });
}

function adjustSwatchesHeight(section) {
  const cards = section.querySelectorAll('.recomendation-card');
  let cardSwatchesMaxHeight = 0;

  cards.forEach((card) => {
    card.querySelectorAll('.recomendation-card__swatches').forEach((swatch) => {
      cardSwatchesMaxHeight = Math.max(cardSwatchesMaxHeight, swatch.offsetHeight);
    });
  });

  cards.forEach((card) => {
    card.querySelectorAll('.recomendation-card__swatches').forEach((swatch) => {
      swatch.style.height = `${cardSwatchesMaxHeight}px`;
    });
  });
}

function initSwatchColors(section) {
  section.querySelectorAll('.recomendation-card__swatches-container').forEach((container) => {
    const swatches = container.querySelectorAll('.recomendation-card__swatch');
    const cardImage = container.closest('.recomendation-card').querySelector('.recomendation-card__img');

    swatches.forEach((swatch, index) => {
      if (index === 0) swatch.classList.add('active');

      swatch.addEventListener('click', function () {
        const active = container.querySelector('.recomendation-card__swatch.active');
        if (active) active.classList.remove('active');

        this.classList.add('active');

        const newImage = this.dataset.imageVariantUrl;
        if (newImage && cardImage) {
          container.classList.add('hover-disabled');
          cardImage.src = newImage;
        }
      });
    });
  });
}

function initProductRecommendationsSwiper(section) {
  const container = section.querySelector('.product-recommendations__container');
  if (!container || container.swiper) return;

  const layoutCards = () => {
    equalizeCardHeights(section);
    adjustSwatchesHeight(section);
  };

  new Swiper(container, {
    slidesPerView: 1.5,
    centerInsufficientSlides: true,
    spaceBetween: 30,
    freeMode: true,
    breakpoints: {
      600: { slidesPerView: 2.5 },
      800: { slidesPerView: 3.5 },
      1220: { slidesPerView: 4.5 },
      1500: { slidesPerView: 5.5 },
    },
    on: {
      init() {
        initSwatchColors(section);
        layoutCards();
      },
      resize() {
        setTimeout(layoutCards, 200);
      },
    },
  });
}

function initProductRecommendations() {
  const section = document.querySelector('.product-recommendations');
  if (!section || typeof recommendationsSettings === 'undefined') return;

  const hasContent = section.querySelector('.recomendation-card');

  if (hasContent) {
    initProductRecommendationsSwiper(section);
    return;
  }

  const { routes, product_id, section_id, limit, intent } = recommendationsSettings;
  const url = `${routes.product_recommendations_url}?product_id=${product_id}&section_id=${section_id}&limit=${limit}&intent=${intent}`;

  fetchRecommendationsSection(url, '.product-recommendations', section)
    .then((loaded) => {
      if (loaded) initProductRecommendationsSwiper(section);
    })
    .catch((error) => console.error(error));
}

function initFeatureProductRecommendations() {
  const section = document.querySelector('.feature-product-recommendations');
  if (!section || typeof featureRecommendationSettings === 'undefined') return;

  const hasContent = section.querySelector('.feature-product-recommendations__title');

  if (hasContent) return;

  const { routes, product_id, section_id, limit, intent } = featureRecommendationSettings;
  const url = `${routes.product_recommendations_url}?product_id=${product_id}&section_id=${section_id}&limit=${limit}&intent=${intent}`;

  fetchRecommendationsSection(url, '.feature-product-recommendations', section)
    .catch((error) => console.error(error));
}
